module.exports = __webpack_public_path__ + "media/preview/meetup@4x-1e69a202.png";